import type { ReactNode } from 'react';

type PageSize = 'narrow' | 'default' | 'wide';

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  size?: PageSize;
}

const sizeMap: Record<PageSize, string> = {
  narrow: 'max-w-lg',
  default: 'max-w-3xl',
  wide: 'max-w-6xl',
};

export default function PageContainer({ children, className = '', size = 'narrow' }: PageContainerProps) {
  return (
    <div className={`${sizeMap[size]} mx-auto w-full px-6 py-8 md:px-8 md:py-12 lg:px-12 ${className}`}>
      {children}
    </div>
  );
}
